module.exports = __webpack_public_path__ + "static/github-e2a239e40488895961f7cad8345c5ad0.png";